<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Tags from '@/components/android/Tags.vue';

const store = useStore();
const info = computed(() => store.state.appInfo);
</script>
<template>
  <div>
    <div class="introduce">
      <div class="flex align-center title">
        <h2>{{ info.language_list.about_app.title }}</h2>
        <i
          class="iconfont icon-youjiantou"
          @click="handleConfirm"></i>
      </div>
      <Tags v-if="info.template_id === 5"></Tags>
      <div>
        {{ info.introduce }}
      </div>
    </div>
    <div
      :class="[
        'update-box',
        info.template_id === 2 || info.template_id === 5 ? 'txt-l' : 'txt-r',
      ]">
      <h3>
        {{ info.language_list.about_app.update }}
        <i class="iconfont icon-jiaofuriqi"></i>
      </h3>
      <p>{{ info.update_data }}</p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.introduce {
  h2 {
    color: #202124;
  }
  div {
    white-space: pre-wrap;
  }
}
.txt-l {
  text-align: left;
}
.txt-r {
  text-align: right;
}
.update-box {
  margin: 24px 0;

  h3 {
    font-size: 14px;
    font-weight: bold;
    color: var(--main-color);
  }
  p {
    margin-top: 4px;
  }
}
</style>
